import { useQuery } from "@tanstack/react-query";
import { IOrganizationApi } from "@/api/organization";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const useOrganizations = (query?: string) => {
  const organizationApi = useInjection<IOrganizationApi>(SERVICES_TYPES.ORGANIZATION);

  return useQuery({
    queryKey: ["organizations", query],
    queryFn: () => organizationApi.getAll(query)
  });
};
